(function() {
    'use strict';

    angular
        .module('signatureApp', ['corePRUGAGreatApp'])
//        .run(run);
//
//    run.$inject = ['stateHandler'];
//
//    function run(stateHandler) {
//        stateHandler.initialize();
//    }
})();
